import sessionConstants from '../constants/sessionConstants';

const initialState = {
  sessions: [],
  session: {},
  comments: [],
};

export default function session(state = initialState, action) {
  switch (action.type) {
    case sessionConstants.GET_ALL_SESSION_REQUEST:
      return {
        ...state,
        requesting: true,
      };
    case sessionConstants.GET_ALL_SESSION_SUCCESS:
      return {
        ...state,
        sessions: action.sessions,
        requesting: false,
      };
    case sessionConstants.GET_ALL_SESSION_FAILURE:
      return {
        ...state,
        requesting: false,
      };
    case sessionConstants.GET_SESSION_REQUEST:
      return {
        ...state,
        requestingSession: true,
      };
    case sessionConstants.GET_SESSION_SUCCESS:
      return {
        ...state,
        requestingSession: false,
        session: action.session,
      };
    case sessionConstants.GET_SESSION_FAILURE:
      return {
        ...state,
        requestingSession: false,
      };
    case sessionConstants.ADD_SESSION_REQUEST:
      return {
        ...state,
        requestingCreate: true,
        createdSession: false,
      };
    case sessionConstants.ADD_SESSION_SUCCESS:
      return {
        ...state,
        requestingCreate: false,
        createdSession: true,
      };
    case sessionConstants.ADD_SESSION_FAILURE:
      return {
        ...state,
        requestingCreate: false,
        createdSession: false,
      };
    case sessionConstants.UPDATE_SESSION_REQUEST:
      return {
        ...state,
        updated: false,
        requestingUpdate: true,
      };
    case sessionConstants.UPDATE_SESSION_SUCCESS:
      return {
        ...state,
        requestingUpdate: false,
        updated: true,
      };
    case sessionConstants.UPDATE_SESSION_FAILURE:
      return {
        ...state,
        requestingUpdate: false,
        updated: false,
      };
    case sessionConstants.DELETE_SESSION_REQUEST:
      return {
        ...state,
        requestingDelete: true,
        deleted: false,
      };
    case sessionConstants.DELETE_SESSION_SUCCESS:
      return {
        ...state,
        requestingDelete: false,
        deleted: true,
      };
    case sessionConstants.DELETE_SESSION_FAILURE:
      return {
        ...state,
        requestingDelete: false,
        deleted: false,
      };
    case sessionConstants.REMOVE_REGISTRANT_REQUEST:
      return {
        ...state,
        requesting: true,
        removedRegistrant: false,
      };
    case sessionConstants.REMOVE_REGISTRANT_SUCCESS:
      return {
        ...state,
        requesting: false,
        removedRegistrant: true,
      };
    case sessionConstants.REMOVE_REGISTRANT_FAILURE:
      return {
        ...state,
        requesting: false,
        removedRegistrant: false,
      };
    case sessionConstants.ADD_COMMENT_REQUEST:
      return {
        ...state,
        requestingComment: true,
        createdComment: false,
      };
    case sessionConstants.ADD_COMMENT_SUCCESS:
      return {
        ...state,
        requestingComment: false,
        createdComment: true,
      };
    case sessionConstants.ADD_COMMENT_FAILURE:
      return {
        ...state,
        requestingComment: false,
        createdComment: false,
      };
    case sessionConstants.GET_COMMENT_REQUEST:
      return {
        ...state,
        requestingComment: false,
      };
    case sessionConstants.GET_COMMENT_SUCCESS:
      return {
        ...state,
        comments: action.comments,
        requestingComment: false,
      };
    case sessionConstants.GET_COMMENT_FAILURE:
      return {
        ...state,
        requestingComment: false,
      };
    case sessionConstants.DELETE_COMMENT_REQUEST:
      return {
        ...state,
        requestingDelete: true,
        deletedComment: false,
      };
    case sessionConstants.DELETE_COMMENT_SUCCESS:
      return {
        ...state,
        requestingDelete: false,
        deletedComment: true,
      };
    case sessionConstants.DELETE_COMMENT_FAILURE:
      return {
        ...state,
        requestingDelete: false,
        deletedComment: false,
      };
    case sessionConstants.CREATE_ZOOM_REQUEST:
      return {
        ...state,
        requestingZoom: true,
        createdMeeting: false,
      };
    case sessionConstants.CREATE_ZOOM_SUCCESS:
      return {
        ...state,
        requestingZoom: false,
        session: action.session,
        createdMeeting: true,
      };
    case sessionConstants.CREATE_ZOOM_FAILURE:
      return {
        ...state,
        requestingZoom: false,
        createdMeeting: false,
      };
    case sessionConstants.DELETE_ZOOM_REQUEST:
      return {
        ...state,
        requestingZoom: true,
        deletedMeeting: false,
      };
    case sessionConstants.DELETE_ZOOM_SUCCESS:
      return {
        ...state,
        requestingZoom: false,
        deletedMeeting: true,
      };
    case sessionConstants.DELETE_ZOOM_FAILURE:
      return {
        ...state,
        requestingZoom: false,
        deletedMeeting: false,
      };
    default:
      return state;
  }
}
